import React from "react";
import "../../../assests/css/students/CourseCard.css";
import { useNavigate } from "react-router-dom";

/* Images import */
import itImg from "../../../assests/Images/it.jpg";
// import csImg from "../../../assests/images/cs.webp";
import islamicImg from "../../../assests/Images/islm.jpg";
// import mobileImg from "../../../assests/images/mobile.jpg";
import psychologyImg from "../../../assests/Images/psy.jpg";
import mathImg from "../../../assests/Images/mth.webp";
//  import commerceImg from "../../../assests/images/comm.png";
 import educationImg from "../../../assests/Images/edu.jpg";
// import zoologyImg from "../../../assests/images/zoology.jpg";
 import botanyImg from "../../../assests/Images/bot.jpg";
// import englishImg from "../../../assests/images/english.jpg";

const courses = [
  { title: "IT", desc: "Information Technology fundamentals including computer systems, networking, web technologies, databases, and IT support concepts.", image: itImg },
  // { title: "Computer Science (CS)", desc: "Programming fundamentals, data structures, algorithms, databases, operating systems, and software engineering concepts.", image: csImg },
  { title: "Islamic Studies", desc: "Introduction to Islamic teachings including the Quran, Hadith, beliefs, moral values, and Islamic history.", image: islamicImg },
  // { title: "Mobile Application Development", desc: "Design and development of modern mobile apps for Android and iOS using React Native and Flutter.", image: mobileImg },
  { title: "Psychology", desc: "Study of human behavior and mental processes including emotions, learning, personality, and development.", image: psychologyImg },
  { title: "Mathematics", desc: "Understanding numbers, algebra, geometry, calculus, and logical problem-solving techniques.", image: mathImg },
  // { title: "Commerce", desc: "Business studies including accounting, economics, finance, trade, and management principles.", image: commerceImg },
   { title: "Education", desc: "Teaching methodologies, learning theories, curriculum development, and classroom management.", image: educationImg },
  // { title: "Zoology", desc: "Study of animal life including structure, behavior, physiology, genetics, and ecology.", image: zoologyImg },
  { title: "Botany", desc: "Study of plant life covering structure, growth, reproduction, classification, and ecology.", image: botanyImg },
  // { title: "English", desc: "Development of reading, writing, speaking, grammar, and communication skills.", image: englishImg },
];

const CourseCard = () => {
  const navigate = useNavigate();

  return (
    <section className="courses-section">
      <h2 className="courses-heading">Our Department</h2>

      <div className="slider-wrapper">
        <div className="slider-track">
          {[...courses, ...courses].map((course, index) => (
            <div
              className="course-card"
              key={index}
              style={{ backgroundImage: `url(${course.image})` }}
            >
              <div className="card-overlay">
                <h3>{course.title}</h3>
                <p>{course.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className="see-more-btn" onClick={() => navigate("/courses")}>
        See More
      </button>
    </section>
  );
};

export default CourseCard;
